import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  allMainCategoryApi,
  subChildCatergoryApi,
} from "../../../Apis/CategoryApi";

// Importing category images (assuming these are static assets)
import camera from "../../../assets/homepage/hero/categories/TopCategories/Consumer Electronics.png";
import home from "../../../assets/homepage/hero/categories/TopCategories/Home & Garden.png";
import beauty from "../../../assets/homepage/hero/categories/beauty.png";
import fashion from "../../../assets/homepage/hero/categories/TopCategories/Fashion & Apparels.png";
import machinery from "../../../assets/homepage/hero/categories/TopCategories/Industrial Machinery.png";
import babyCare from "../../../assets/homepage/hero/categories/TopCategories/baby care.png";
import sports from "../../../assets/homepage/hero/categories/TopCategories/Sports & Entertainment.png";
import sustainable from "../../../assets/homepage/hero/categories/sustainibilityLogo.png";
import toys from "../../../assets/homepage/hero/categories/TopCategories/toys.png";
import { HeroCategorySVG, ShowMoreSVG } from "../../../assets/svg/allSvg";

const CategorySection = () => {
  const [mainCategory, setMainCategory] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMainCategories = async () => {
      try {
        const response = await allMainCategoryApi();
        if (response && response.category) {
          // Initialize main categories with subCategories as empty array
          const initializedCategories = response.category.map((category) => ({
            name: category,
            subCategories: [],
          }));
          setMainCategory(initializedCategories?.slice(0, 8));
        } else {
          console.error("Failed to fetch main categories:", response);
        }
      } catch (error) {
        console.error("Error fetching main categories", error);
      }
    };

    fetchMainCategories();
  }, []);

  const fetchSubCategories = async (selectedMainCategory) => {
    try {
      const response = await subChildCatergoryApi(selectedMainCategory);
      if (response && response.category) {
        return response.category; // Return the fetched subcategories
      } else {
        console.error("Failed to fetch subcategories:", response);
        return []; // Return an empty array on failure
      }
    } catch (error) {
      console.error("Error fetching subcategories", error);
      return []; // Return an empty array on error
    }
  };

  const categoryImages = {
    "Consumer Electronics": camera,
    "Fashion & Apparel": fashion,
    "Industrial Machines": machinery,
    "Sports & Entertainment": sports,
    "Home and Decor": home,
    "Baby care": babyCare,

    "Beauty & Personal Care": beauty,
    "Sustainable Products": sustainable,
    Toys: toys,
  };

  const SmCategories = [
    {
      image: require("../../../assets/homepage/hero/categories/TopCategories/Fashion & Apparels.png"),
      category: "Fashion & Apparels",
      bgColor: "bg-[#CDEAFF]",
    },
    {
      image: require("../../../assets/homepage/hero/categories/TopCategories/Consumer Electronics.png"),
      category: "Consumer Electronics",
      bgColor: "bg-[#D2FFBD]",
    },
    {
      image: require("../../../assets/homepage/hero/categories/TopCategories/Sports & Entertainment.png"),
      category: "Sports & Entertainment",
      bgColor: "bg-[#FFF7CB]",
    },
  ];

  const [currentCategory, setCurrentCategory] = useState(null);
  const [showPanel, setShowPanel] = useState(false);
  const [mainCategoryIndex, setMainCategoryIndex] = useState(0);

  const handleMouseEnter = async (index, category) => {
    setShowPanel(true);
    const subCategories = await fetchSubCategories(category);
    // Update the mainCategory state to include fetched subcategories
    setMainCategory((prevMainCategory) => {
      const updatedMainCategory = [...prevMainCategory];
      updatedMainCategory[index].subCategories = subCategories;
      return updatedMainCategory;
    });
  };

  const handleMouseLeave = () => {
    setShowPanel(false);
    setCurrentCategory(null);
  };

  return (
    <>
      {/* Code for Larger Device */}
      <div className="hidden lg:flex" onMouseLeave={handleMouseLeave}>
        <div className="w-[271px] h-[476px] rounded-[6px] bg-white border flex flex-col">
          <div className="gap-x-[9px] flex items-center justify-start w-[270px] h-[30px] mt-[8px] mb-[15px] pl-[16px]">
            {HeroCategorySVG}
            <div className="font-semibold text-[16px] text-left select-none">
              Top Categories
            </div>
          </div>

          <ul className="flex flex-col gap-y-[12px] w-[271px] pl-[16px]">
            {mainCategory.length > 0 ? (
              mainCategory.map((item, index) => (
                <div className="flex items-center gap-x-2">
                  <div className="bg-[#F2F2F2] rounded-full w-[34px] h-[34px] flex items-center justify-center">
                    <img
                      src={categoryImages[item.name]}
                      alt={item.name}
                      className="w-[18px] h-[17px]"
                    />
                  </div>
                  <li
                    className="group flex items-start justify-start text-[14px] cursor-pointer hover:text-[#FF6300]"
                    onMouseEnter={() => {
                      handleMouseEnter(index, item.name);
                      setMainCategoryIndex(index);
                    }}
                  >
                    <button className="select-none cursor-pointer text-start">
                      {item.name}
                    </button>
                  </li>
                </div>
              ))
            ) : (
              <li className="font-medium text-[14px]">No Categories</li>
            )}
          </ul>

          <div className="flex items-end justify-start w-[271px] text-[#ff6300] underline pl-[16px] h-[45px] text-[14px] font-medium">
            <button onClick={() => navigate("/Categories")}>
              View All Categories
            </button>
          </div>
        </div>

        {showPanel && (
          <div className="w-[945px] h-[478px] overflow-y-scroll p-4 bg-white rounded-[10px] absolute left-[283px] top-[15px] border shadow-[0_0px_1px_2px_rgba(0,0,0,0.01)] z-40">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
              {mainCategory[mainCategoryIndex]?.subCategories?.length > 0 ? (
                <>
                  {mainCategory[mainCategoryIndex]?.subCategories?.map(
                    (subItem) => (
                      <div key={subItem}>
                        <div className="text-black cursor-pointer text-[14px] font-semibold">
                          {subItem.subCategory}
                        </div>
                        <ul className="">
                          {subItem?.childCategory
                            ?.slice(0, 4)
                            ?.map((childItem, childIndex) => (
                              <li
                                key={childIndex}
                                className="text-black hover:text-[#FF6300] cursor-pointer text-[13px] mt-2 font-medium"
                              >
                                {childItem?.childCategory?.slice(0, 26)}
                              </li>
                            ))}
                        </ul>
                        {subItem.childCategory?.length > 4 && (
                          <div className="mt-[12px]">
                            <button
                              className="flex items-center text-[#FF6300] cursor-pointer text-[12px] font-normal"
                              onClick={() => navigate("/AllProductsPage")}
                            >
                              Show More
                              {ShowMoreSVG}
                            </button>
                          </div>
                        )}
                      </div>
                    )
                  )}
                </>
              ) : (
                <div className="text-black font-medium text-[14px]">
                  No Sub-Categories
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Code for smaller device */}
      <div className="md:hidden flex flex-col w-[328px] h-[192px]">
        <h3 className="w-[109px] h-[21px] font-semibold text-[14px] text-black mb-[8px]">
          Top categories
        </h3>
        <hr className="w-[136px] h-[4px] bg-[#FF6300] rounded-full" />
        <div className="flex flex-row items-center justify-between mt-[16px]">
          {SmCategories.map((item, index) => (
            <div key={index}>
              <button className="w-[100px] h-[143px] border shadow-[0_0px_1px_2px_rgba(0,0,0,0.01)] rounded-[10px] flex flex-col overflow-hidden px-[6px] py-[10px] justify-between">
                <div className="relative">
                  <div
                    className={`w-[113px] h-[113px] ${item.bgColor} rounded-full absolute top-[30px] left-[20px] transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center`}
                  >
                    <img
                      src={item.image}
                      alt=""
                      className="w-[39px] h-[48px] relative top-[7px] -right-[7px] object-cover"
                    />
                  </div>
                </div>
                <p className="text-[12px] font-semibold w-full h-[32px] text-start">
                  {item.category}
                </p>
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CategorySection;
